import AlunmiImage from "../../../../../assets/images/svg/incubation.svg";
import LearnImage from "../../../../../assets/images/svg/intensive-learning.svg";
import BuildingImage from "../../../../../assets/images/svg/internship.svg";
import SupportImage from "../../../../../assets/images/svg/people-primary.svg";
import AiPreview from "../../../../../assets/images/jpeg/aiPreview.jpg";

import Instructor1 from "../../../../../assets/images/png/courses/instructors/trainers pictures/PRINCEWILL SUIT - AI Automation Practice Lead.png";
import OmobosolaImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/OMOBOSOLA SUIT - Product & Digital Marketing and AI Automation Support Person.png";
import RachaelImage from "../../../../../assets/images/png/courses/instructors/rachael.webp";
import DoluImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/Ayotunde1.webp";
import FaithImage from "../../../../../assets/images/png/courses/instructors/trainers pictures/FAITH Customer Success Manager.png";

export const aiAutomationAfrica = {
  id: 1,
  tag: "FOR STARTERS",
  title: "AI Automation Diploma",
  seoTitle: "AI Automation Diploma Nigeria | Become an AI Automation Expert",
  description: `
  The Utiva AI Automation Diploma is a 12-week practical, virtual learning programme focused on
  AI tools, automation platforms and workflow design. Learners build automation systems that
  solve real business problems and develop the ability to connect AI decision-making with
  automated execution.
    `,
  heroSubtitle: `Move beyond isolated AI prompts — design complete systems where information is received, processed by AI, routed through an automation workflow, and converted into a useful business output.`,
  heroHighlights: [
    "Understand how AI tools and workflow automation work together",
    "Design repeatable processes that reduce manual work",
    "Use no-code and low-code platforms to connect applications and data",
    "Build AI-enabled systems for real organisational functions",
    "Develop a portfolio of practical automation projects",
  ],
  metatags: `Master AI Automation, prompt engineering, workflow design, and intelligent systems. Get job-ready with Utiva's AI Automation Diploma — the #1 choice in Nigeria.`,
  keywords: `AI Automation Diploma, AI Automation Course Online, Artificial Intelligence Automation Training, Learn AI Automation, AI Automation Certification, AI Automation Diploma | Learn AI & Automation Online | Utiva, AI workflow automation course, Business process automation with AI, Generative AI for business professionals, AI tools for automation, No-code AI automation training, Prompt engineering course, ChatGPT for business automation, Make.com course online, Zapier and AI automation, AI agent training, Agentic AI workflows, LLM applications for business, AI diploma program Africa, Tech skills training Nigeria, Online tech certification Africa, How to learn AI automation online in Africa, Best AI automation course for beginners, AI automation diploma for non-technical professionals, How to automate business processes with AI, What is AI workflow automation, AI automation skills for career growth, Online AI certification with job-ready skills, How to use ChatGPT to automate work tasks, AI tools every professional should know in 2025, Is AI automation a good career in Nigeria?, How long does it take to learn AI automation?, What jobs can AI automation skills get you?, What is the Utiva AI Automation Diploma?, Who is the AI Automation Diploma for?, What will I learn in the AI Automation Diploma course?, How long is the Utiva AI Automation course?, Does the Utiva AI Automation Diploma include a certificate?, Can I learn AI automation with no coding experience?, What tools are covered in the AI Automation Diploma?, How much does the Utiva AI Automation Diploma cost?, Is Utiva's AI Automation course accredited?, What career opportunities does AI automation training open up?`,
  duration: "3 months",
  downloadBrochureUrl:
    "https://drive.google.com/file/d/19RZifmFEHti3MOb3CHeYlVMRa94qbKTg/view?usp=sharing",

  courseFormUrl: "courses/ai-automation-diploma/fill-form",

  jobTitle: "AI Automation Specialist",

  kickoffDate: "December 2",
  kickoffTime: (
    <>
      Saturday 10:00 AM - 1:00 PM WAT
      <br />
      Sunday 2:00 PM - 5:00 PM WAT
    </>
  ),

  testimonial: {
    // image: Testimony2,
    name: "James M.",
    role: "AI Automation Specialist",
    testimony: `
    I was looking for something a little more than a training, a school I 
    could count on for my continuous skill and professional development. 
    Utiva kept coming up so I jumped in. I went through the Development
    program and now I am an AI Automation specialist.`,
    starRating: "5.0",
    date: "August 2025",
  },

  courseOverview: {
    title: `Build, Not Just Watch.`,
    desc: `
    AI Automation specialists play an increasingly important role as they help organizations
    eliminate repetitive work, streamline operations, and build intelligent systems. Throughout
    this course, you will work on real-world projects building automation systems using platforms
    like Zapier, Make, and n8n, while mastering prompt engineering, API integrations, and
    AI-powered assistants.
    `,
  },

  keyOutcomesHeading: "How AI and Automation Work Together",

  keyOutcomes: [
    {
      label: "Trigger",
      desc:
        "Capture information from a form, message, email, or scheduled event that starts the workflow.",
    },
    {
      label: "Process",
      desc:
        "Use AI to understand, classify, summarise, or generate a useful result from the input.",
    },
    {
      label: "Automate",
      desc:
        "Apply rules, filters, and routers to decide the next action and execute it in another tool.",
    },
    {
      label: "Track",
      desc: "Store the outcome for follow-up, reporting, and quality control.",
    },
  ],

  courseOutlines: [
    {
      unitId: 1,
      unitTitle: "Introduction to AI and Automation",
      unitTag: "Fundamentals",
      unitDescription: `
      Learn the fundamentals of Artificial Intelligence and automation systems. Understand 
      how AI works, how automation is transforming business operations, and how intelligent 
      systems eliminate repetitive work. Explore the AI automation ecosystem and real-world 
      use cases.
        `,
    },
    {
      unitId: 2,
      unitTitle: "Prompt Engineering and AI Productivity",
      unitTag: "AI",
      unitDescription: `
      Master prompt engineering to work effectively with modern AI systems. Learn to design 
      high-quality prompts, use prompt chaining and templates, and build AI-powered 
      productivity workflows for writing, research, reporting, and operational support.
        `,
    },
    {
      unitId: 3,
      unitTitle: "Automation Thinking and Workflow Design",
      unitTag: "Design",
      unitDescription: `
      Learn how to analyze business processes and design automation workflows. Map workflows, 
      structure automation logic, and design systems that connect multiple tools and services 
      using core automation architecture frameworks.
        `,
    },
    {
      unitId: 4,
      unitTitle: "Automation with Zapier",
      unitTag: "Platform",
      unitDescription: `
      Build automation workflows using Zapier to connect different tools and applications. 
      Learn how triggers, actions, webhooks, and integrations work to automate sales, 
      marketing, and operational workflows.
        `,
    },
    {
      unitId: 5,
      unitTitle: "Automation with Make (Integromat)",
      unitTag: "Platform",
      unitDescription: `
      Design advanced automation workflows through visual automation architecture using Make. 
      Learn multi-step workflows, data mapping between systems, conditional automation logic, 
      and error handling in workflows.
        `,
    },
    {
      unitId: 6,
      unitTitle: "Automation with n8n",
      unitTag: "Platform",
      unitDescription: `
      Design event-driven automation systems using n8n's node-based workflows and APIs. 
      Learn webhooks, triggers, data transformation, and advanced automation logic to create 
      powerful automation pipelines.
        `,
    },
    {
      unitId: 7,
      unitTitle: "Data Systems for Automation",
      unitTag: "Data",
      unitDescription: `
      Design data systems that support automation workflows. Learn to structure data using 
      Airtable, build data pipelines for automation, create automation dashboards, and 
      implement data-driven decision systems.
        `,
    },
    {
      unitId: 8,
      unitTitle: "Application Integration",
      unitTag: "Integration",
      unitDescription: `
      Connect communication, productivity, data, customer and operational tools within one
      process. Learn REST API fundamentals, API authentication, webhooks, and how to integrate
      APIs into automation systems to build complete automation ecosystems.
        `,
    },
    {
      unitId: 9,
      unitTitle: "AI Agents",
      unitTag: "AI",
      unitDescription: `
      Explore intelligent systems that combine AI reasoning or decision-making with automated
      actions. Build AI assistants, conversational automation, chatbot systems, and multi-agent
      workflows that operate across a process.
        `,
    },
    {
      unitId: 10,
      unitTitle: "Business Process Automation",
      unitTag: "Business",
      unitDescription: `
      Apply automation to marketing, sales, HR, customer onboarding and operations. Design
      workflows using real-world business automation strategies across multiple functions.
        `,
    },
    {
      unitId: 11,
      unitTitle: "Testing and Improvement",
      unitTag: "Quality",
      unitDescription: `
      Test workflows, identify failures, improve reliability and refine the user experience.
      Run sample inputs, catch missing data or unreliable outputs, and iterate on prompts,
      routing, and data handling.
        `,
    },
    {
      unitId: 12,
      unitTitle: "Solution Presentation and Capstone Project",
      unitTag: "Project",
      unitDescription: `
      Apply everything you've learned to design, deploy, and present a complete AI automation
      system addressing a real-world business problem — explaining the business problem, system
      design, tools, outputs, and value of your solution.
        `,
    },
  ],

  courseCoaches: [
    {
      coachId: 1,
      coachImage: Instructor1,
      coachName: "Princewill Ogbu",
      coachRole: "AI Automation Practice Lead",
    },
    {
      coachId: 2,
      coachImage: RachaelImage,
      coachName: "Rachael Wilson",
      coachRole: "Senior Data Analyst",
    },
    {
      coachId: 3,
      coachImage: DoluImage,
      coachName: "Doluwamu Ayotunde Solana",
      coachRole: "Senior Data Scientist",
    },
    {
      coachId: 4,
      coachImage: FaithImage,
      coachName: "Faith",
      coachRole: "Customer Success Manager",
    },
    {
      coachId: 5,
      coachImage: OmobosolaImage,
      coachName: "Omobosola Olafimihan",
      coachRole: "AI Automation Support",
    },
  ],

  learningModels: [
    {
      modelId: 1,
      modelIcon: LearnImage,
      modelTitle: "HANDS-ON PRACTICE",
      modelDescription:
        "Actively build workflows and AI-supported systems throughout the programme using platforms like Zapier, Make, and n8n.",
    },
    {
      modelId: 2,
      modelIcon: SupportImage,
      modelTitle: "LIVE WEEKEND CLASSES",
      modelDescription:
        "Instructor-led virtual sessions provide explanation, guided building, demonstrations, and feedback.",
    },
    {
      modelId: 3,
      modelIcon: BuildingImage,
      modelTitle: "PROJECT-BASED LEARNING",
      modelDescription:
        "Practical projects connect tools and concepts to real business problems, building toward a final capstone system.",
    },
    {
      modelId: 4,
      modelIcon: AlunmiImage,
      modelTitle: "MENTORSHIP & PEER SESSIONS",
      modelDescription:
        "Mentorship helps you clarify concepts and improve solutions, while peer sessions let you compare approaches and solve problems together.",
    },
  ],

  studentTestimonies: [],

  portofolio: {
    title: "Build Real AI Automation Systems",
    description: `
    By the end of the programme, you will have built multiple automation systems — an AI
    productivity assistant, sales automation workflow, marketing workflow, customer support
    automation, HR or onboarding workflow, and operations automation — culminating in a
    capstone AI automation system that solves a real business problem.
      `,

    deliverables: [
      "A clearly defined business problem and target user",
      "A process map showing the original and automated workflow",
      "A working automation scenario with AI integration",
      "Test cases showing successful and unsuccessful inputs",
      "Error handling and human escalation where appropriate",
      "A short implementation guide or user instructions",
      "A presentation explaining the solution and measurable value",
    ],

    name: "James Miles",
    // image: PortfolioUserAvatar,
    // portfolioImage: PortfolioImage,
  },

  certification: {
    title: "Earn a Utiva AI Automation Certification",
    description: `
    Upon completing Utiva's AI Automation Diploma, you'll receive an 
    industry-recognized, professional AI Automation certification to 
    share with your network and showcase all that you've 
    learned. Utiva certificates are formatted for sharing on LinkedIn 
      `,
  },

  // videoTestimonial: "https://www.youtube.com/embed/T005noz-SRo",
  // videoTestimonial: "https://www.youtube.com/embed/3sdVr3gc9j8",
  videoTestimonial: "https://www.youtube.com/embed/jNakIRY7LaA",
  videoPreviewImage: AiPreview,

  otherCourses: [
    {
      id: 2,
      courseTitle: "Data Analytics Bootcamp",
      courseDescription: `This program is designed to help you apply the important ML techniques for solving 
      real business problems and also help you make key data-driven decisions for business growth.  `,
      courseUrl: "/courses/data-analytics-bootcamp",
    },
  ],
};
